/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Box, TextField, LinearProgress } from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useAuthSap } from '../../hooks';

const filter = createFilterOptions();
export default function LineVendorSearchForm(props){
  const { send } = props;
  const { collectionQuery, BussinessPartnersQuery } = useAuthSap();
  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await BussinessPartnersQuery('');
      setLoading(false);
    };
    fetchData();
  }, []);
  
  if (loading) {
    return (
      <Box sx={{ width: '100%' }}>
        <LinearProgress />
      </Box>
    );
  }

  return (
    <Autocomplete
      value={value}
      onChange={(event, newValue) => {
        if (typeof newValue === 'string') {
          setValue({CardName: newValue});
          send(newValue);
        } else if (newValue && newValue.inputValue) {
          setValue({CardName: newValue.inputValue});
          send(newValue);
        } else {
          setValue(newValue);
          send(newValue);
        }
      }}
      filterOptions={(options, params) => {
        const filtered = filter(options, params).slice(0, 50);
        return filtered;
      }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      id="LineVendor"
      options={collectionQuery}
      getOptionLabel={(option) => {
        if (typeof option === 'string') {
          return option;
        }
        if (option.inputValue) {
          return option.inputValue;
        }
          return option.CardName;
      }}
      renderOption={(props, option) => <li {...props}>{option.CardCode} - {option.CardName}</li>}
      fullWidth
      freeSolo
      renderInput={(params) => (
        <TextField {...params} label="Proveedor" />
      )}
    />
  )
}
